export default "__VITE_ASSET__BhrKAdBf__"